
interface ContentPreviewProps {
  content: string;
}

const ContentPreview = ({ content }: ContentPreviewProps) => {
  return (
    <div 
      className="p-4 border rounded-md bg-white max-h-[500px] overflow-y-auto" 
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default ContentPreview;
